import { useSurveyTemplateQuery } from 'documents/surveyTemplate.generated';

export const useSurveyTemplate = (surveyTemplateId: string) => {
  const { data: surveyTemplateData, loading: isSurveyTemplateLoading } = useSurveyTemplateQuery({
    variables: { surveyTemplateId },
  });

  return { surveyTemplateData, isSurveyTemplateLoading };
};
